import { IS_LOADING, ERROR } from "./infoConstants";
import { updateIn } from '../../lib/immutable_wrapper'

const initialState = {
    loadings: {}
}

export function info(state = initialState, action) {
    switch (action.type) {
        case IS_LOADING: {
            let currentLoading = {
                isLoading: action.isLoading,
                info: action.info,
            }

            return updateIn(state, ['loadings', action.info], () => currentLoading);
        }
        case ERROR:
            return action;
        default:
            return state;
    }
}
